"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: babylon/btcstaking/v1/params.proto
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoredParams = exports.HeightToVersionMap = exports.HeightVersionPair = exports.Params = exports.protobufPackage = void 0;
/* eslint-disable */
const wire_1 = require("@bufbuild/protobuf/wire");
exports.protobufPackage = "babylon.btcstaking.v1";
function createBaseParams() {
    return {
        covenantPks: [],
        covenantQuorum: 0,
        minStakingValueSat: 0,
        maxStakingValueSat: 0,
        minStakingTimeBlocks: 0,
        maxStakingTimeBlocks: 0,
        slashingPkScript: new Uint8Array(0),
        minSlashingTxFeeSat: 0,
        slashingRate: "",
        unbondingTimeBlocks: 0,
        unbondingFeeSat: 0,
        minCommissionRate: "",
        delegationCreationBaseGasFee: 0,
        allowListExpirationHeight: 0,
        btcActivationHeight: 0,
        maxFinalityProviders: 0,
    };
}
exports.Params = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.covenantPks) {
            writer.uint32(10).bytes(v);
        }
        if (message.covenantQuorum !== 0) {
            writer.uint32(16).uint32(message.covenantQuorum);
        }
        if (message.minStakingValueSat !== 0) {
            writer.uint32(24).int64(message.minStakingValueSat);
        }
        if (message.maxStakingValueSat !== 0) {
            writer.uint32(32).int64(message.maxStakingValueSat);
        }
        if (message.minStakingTimeBlocks !== 0) {
            writer.uint32(40).uint32(message.minStakingTimeBlocks);
        }
        if (message.maxStakingTimeBlocks !== 0) {
            writer.uint32(48).uint32(message.maxStakingTimeBlocks);
        }
        if (message.slashingPkScript.length !== 0) {
            writer.uint32(58).bytes(message.slashingPkScript);
        }
        if (message.minSlashingTxFeeSat !== 0) {
            writer.uint32(64).int64(message.minSlashingTxFeeSat);
        }
        if (message.slashingRate !== "") {
            writer.uint32(74).string(message.slashingRate);
        }
        if (message.unbondingTimeBlocks !== 0) {
            writer.uint32(80).uint32(message.unbondingTimeBlocks);
        }
        if (message.unbondingFeeSat !== 0) {
            writer.uint32(88).int64(message.unbondingFeeSat);
        }
        if (message.minCommissionRate !== "") {
            writer.uint32(98).string(message.minCommissionRate);
        }
        if (message.delegationCreationBaseGasFee !== 0) {
            writer.uint32(104).uint64(message.delegationCreationBaseGasFee);
        }
        if (message.allowListExpirationHeight !== 0) {
            writer.uint32(112).uint64(message.allowListExpirationHeight);
        }
        if (message.btcActivationHeight !== 0) {
            writer.uint32(120).uint32(message.btcActivationHeight);
        }
        if (message.maxFinalityProviders !== 0) {
            writer.uint32(128).uint32(message.maxFinalityProviders);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.covenantPks.push(reader.bytes());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.covenantQuorum = reader.uint32();
                    continue;
                }
                case 3: {
                    if (tag !== 24) {
                        break;
                    }
                    message.minStakingValueSat = longToNumber(reader.int64());
                    continue;
                }
                case 4: {
                    if (tag !== 32) {
                        break;
                    }
                    message.maxStakingValueSat = longToNumber(reader.int64());
                    continue;
                }
                case 5: {
                    if (tag !== 40) {
                        break;
                    }
                    message.minStakingTimeBlocks = reader.uint32();
                    continue;
                }
                case 6: {
                    if (tag !== 48) {
                        break;
                    }
                    message.maxStakingTimeBlocks = reader.uint32();
                    continue;
                }
                case 7: {
                    if (tag !== 58) {
                        break;
                    }
                    message.slashingPkScript = reader.bytes();
                    continue;
                }
                case 8: {
                    if (tag !== 64) {
                        break;
                    }
                    message.minSlashingTxFeeSat = longToNumber(reader.int64());
                    continue;
                }
                case 9: {
                    if (tag !== 74) {
                        break;
                    }
                    message.slashingRate = reader.string();
                    continue;
                }
                case 10: {
                    if (tag !== 80) {
                        break;
                    }
                    message.unbondingTimeBlocks = reader.uint32();
                    continue;
                }
                case 11: {
                    if (tag !== 88) {
                        break;
                    }
                    message.unbondingFeeSat = longToNumber(reader.int64());
                    continue;
                }
                case 12: {
                    if (tag !== 98) {
                        break;
                    }
                    message.minCommissionRate = reader.string();
                    continue;
                }
                case 13: {
                    if (tag !== 104) {
                        break;
                    }
                    message.delegationCreationBaseGasFee = longToNumber(reader.uint64());
                    continue;
                }
                case 14: {
                    if (tag !== 112) {
                        break;
                    }
                    message.allowListExpirationHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 15: {
                    if (tag !== 120) {
                        break;
                    }
                    message.btcActivationHeight = reader.uint32();
                    continue;
                }
                case 16: {
                    if (tag !== 128) {
                        break;
                    }
                    message.maxFinalityProviders = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            covenantPks: globalThis.Array.isArray(object?.covenantPks)
                ? object.covenantPks.map((e) => bytesFromBase64(e))
                : [],
            covenantQuorum: isSet(object.covenantQuorum) ? globalThis.Number(object.covenantQuorum) : 0,
            minStakingValueSat: isSet(object.minStakingValueSat) ? globalThis.Number(object.minStakingValueSat) : 0,
            maxStakingValueSat: isSet(object.maxStakingValueSat) ? globalThis.Number(object.maxStakingValueSat) : 0,
            minStakingTimeBlocks: isSet(object.minStakingTimeBlocks) ? globalThis.Number(object.minStakingTimeBlocks) : 0,
            maxStakingTimeBlocks: isSet(object.maxStakingTimeBlocks) ? globalThis.Number(object.maxStakingTimeBlocks) : 0,
            slashingPkScript: isSet(object.slashingPkScript) ? bytesFromBase64(object.slashingPkScript) : new Uint8Array(0),
            minSlashingTxFeeSat: isSet(object.minSlashingTxFeeSat) ? globalThis.Number(object.minSlashingTxFeeSat) : 0,
            slashingRate: isSet(object.slashingRate) ? globalThis.String(object.slashingRate) : "",
            unbondingTimeBlocks: isSet(object.unbondingTimeBlocks) ? globalThis.Number(object.unbondingTimeBlocks) : 0,
            unbondingFeeSat: isSet(object.unbondingFeeSat) ? globalThis.Number(object.unbondingFeeSat) : 0,
            minCommissionRate: isSet(object.minCommissionRate) ? globalThis.String(object.minCommissionRate) : "",
            delegationCreationBaseGasFee: isSet(object.delegationCreationBaseGasFee)
                ? globalThis.Number(object.delegationCreationBaseGasFee)
                : 0,
            allowListExpirationHeight: isSet(object.allowListExpirationHeight)
                ? globalThis.Number(object.allowListExpirationHeight)
                : 0,
            btcActivationHeight: isSet(object.btcActivationHeight) ? globalThis.Number(object.btcActivationHeight) : 0,
            maxFinalityProviders: isSet(object.maxFinalityProviders) ? globalThis.Number(object.maxFinalityProviders) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.covenantPks?.length) {
            obj.covenantPks = message.covenantPks.map((e) => base64FromBytes(e));
        }
        if (message.covenantQuorum !== 0) {
            obj.covenantQuorum = Math.round(message.covenantQuorum);
        }
        if (message.minStakingValueSat !== 0) {
            obj.minStakingValueSat = Math.round(message.minStakingValueSat);
        }
        if (message.maxStakingValueSat !== 0) {
            obj.maxStakingValueSat = Math.round(message.maxStakingValueSat);
        }
        if (message.minStakingTimeBlocks !== 0) {
            obj.minStakingTimeBlocks = Math.round(message.minStakingTimeBlocks);
        }
        if (message.maxStakingTimeBlocks !== 0) {
            obj.maxStakingTimeBlocks = Math.round(message.maxStakingTimeBlocks);
        }
        if (message.slashingPkScript.length !== 0) {
            obj.slashingPkScript = base64FromBytes(message.slashingPkScript);
        }
        if (message.minSlashingTxFeeSat !== 0) {
            obj.minSlashingTxFeeSat = Math.round(message.minSlashingTxFeeSat);
        }
        if (message.slashingRate !== "") {
            obj.slashingRate = message.slashingRate;
        }
        if (message.unbondingTimeBlocks !== 0) {
            obj.unbondingTimeBlocks = Math.round(message.unbondingTimeBlocks);
        }
        if (message.unbondingFeeSat !== 0) {
            obj.unbondingFeeSat = Math.round(message.unbondingFeeSat);
        }
        if (message.minCommissionRate !== "") {
            obj.minCommissionRate = message.minCommissionRate;
        }
        if (message.delegationCreationBaseGasFee !== 0) {
            obj.delegationCreationBaseGasFee = Math.round(message.delegationCreationBaseGasFee);
        }
        if (message.allowListExpirationHeight !== 0) {
            obj.allowListExpirationHeight = Math.round(message.allowListExpirationHeight);
        }
        if (message.btcActivationHeight !== 0) {
            obj.btcActivationHeight = Math.round(message.btcActivationHeight);
        }
        if (message.maxFinalityProviders !== 0) {
            obj.maxFinalityProviders = Math.round(message.maxFinalityProviders);
        }
        return obj;
    },
    create(base) {
        return exports.Params.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseParams();
        message.covenantPks = object.covenantPks?.map((e) => e) || [];
        message.covenantQuorum = object.covenantQuorum ?? 0;
        message.minStakingValueSat = object.minStakingValueSat ?? 0;
        message.maxStakingValueSat = object.maxStakingValueSat ?? 0;
        message.minStakingTimeBlocks = object.minStakingTimeBlocks ?? 0;
        message.maxStakingTimeBlocks = object.maxStakingTimeBlocks ?? 0;
        message.slashingPkScript = object.slashingPkScript ?? new Uint8Array(0);
        message.minSlashingTxFeeSat = object.minSlashingTxFeeSat ?? 0;
        message.slashingRate = object.slashingRate ?? "";
        message.unbondingTimeBlocks = object.unbondingTimeBlocks ?? 0;
        message.unbondingFeeSat = object.unbondingFeeSat ?? 0;
        message.minCommissionRate = object.minCommissionRate ?? "";
        message.delegationCreationBaseGasFee = object.delegationCreationBaseGasFee ?? 0;
        message.allowListExpirationHeight = object.allowListExpirationHeight ?? 0;
        message.btcActivationHeight = object.btcActivationHeight ?? 0;
        message.maxFinalityProviders = object.maxFinalityProviders ?? 0;
        return message;
    },
};
function createBaseHeightVersionPair() {
    return { startHeight: 0, version: 0 };
}
exports.HeightVersionPair = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.startHeight !== 0) {
            writer.uint32(8).uint64(message.startHeight);
        }
        if (message.version !== 0) {
            writer.uint32(16).uint32(message.version);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeightVersionPair();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.startHeight = longToNumber(reader.uint64());
                    continue;
                }
                case 2: {
                    if (tag !== 16) {
                        break;
                    }
                    message.version = reader.uint32();
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            startHeight: isSet(object.startHeight) ? globalThis.Number(object.startHeight) : 0,
            version: isSet(object.version) ? globalThis.Number(object.version) : 0,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.startHeight !== 0) {
            obj.startHeight = Math.round(message.startHeight);
        }
        if (message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        return obj;
    },
    create(base) {
        return exports.HeightVersionPair.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeightVersionPair();
        message.startHeight = object.startHeight ?? 0;
        message.version = object.version ?? 0;
        return message;
    },
};
function createBaseHeightToVersionMap() {
    return { pairs: [] };
}
exports.HeightToVersionMap = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        for (const v of message.pairs) {
            exports.HeightVersionPair.encode(v, writer.uint32(10).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHeightToVersionMap();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 10) {
                        break;
                    }
                    message.pairs.push(exports.HeightVersionPair.decode(reader, reader.uint32()));
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            pairs: globalThis.Array.isArray(object?.pairs) ? object.pairs.map((e) => exports.HeightVersionPair.fromJSON(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.pairs?.length) {
            obj.pairs = message.pairs.map((e) => exports.HeightVersionPair.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.HeightToVersionMap.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseHeightToVersionMap();
        message.pairs = object.pairs?.map((e) => exports.HeightVersionPair.fromPartial(e)) || [];
        return message;
    },
};
function createBaseStoredParams() {
    return { version: 0, params: undefined };
}
exports.StoredParams = {
    encode(message, writer = new wire_1.BinaryWriter()) {
        if (message.version !== 0) {
            writer.uint32(8).uint32(message.version);
        }
        if (message.params !== undefined) {
            exports.Params.encode(message.params, writer.uint32(18).fork()).join();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof wire_1.BinaryReader ? input : new wire_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseStoredParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1: {
                    if (tag !== 8) {
                        break;
                    }
                    message.version = reader.uint32();
                    continue;
                }
                case 2: {
                    if (tag !== 18) {
                        break;
                    }
                    message.params = exports.Params.decode(reader, reader.uint32());
                    continue;
                }
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skip(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            version: isSet(object.version) ? globalThis.Number(object.version) : 0,
            params: isSet(object.params) ? exports.Params.fromJSON(object.params) : undefined,
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.version !== 0) {
            obj.version = Math.round(message.version);
        }
        if (message.params !== undefined) {
            obj.params = exports.Params.toJSON(message.params);
        }
        return obj;
    },
    create(base) {
        return exports.StoredParams.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseStoredParams();
        message.version = object.version ?? 0;
        message.params = (object.params !== undefined && object.params !== null)
            ? exports.Params.fromPartial(object.params)
            : undefined;
        return message;
    },
};
function bytesFromBase64(b64) {
    if (globalThis.Buffer) {
        return Uint8Array.from(globalThis.Buffer.from(b64, "base64"));
    }
    else {
        const bin = globalThis.atob(b64);
        const arr = new Uint8Array(bin.length);
        for (let i = 0; i < bin.length; ++i) {
            arr[i] = bin.charCodeAt(i);
        }
        return arr;
    }
}
function base64FromBytes(arr) {
    if (globalThis.Buffer) {
        return globalThis.Buffer.from(arr).toString("base64");
    }
    else {
        const bin = [];
        arr.forEach((byte) => {
            bin.push(globalThis.String.fromCharCode(byte));
        });
        return globalThis.btoa(bin.join(""));
    }
}
function longToNumber(int64) {
    const num = globalThis.Number(int64.toString());
    if (num > globalThis.Number.MAX_SAFE_INTEGER) {
        throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    if (num < globalThis.Number.MIN_SAFE_INTEGER) {
        throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
    }
    return num;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=params.js.map